/**
 * PB1(1.0 대조 3행) — 2.0 출시 주소 표 한 곳.
 *
 * 운영 Worker 가 세 주소를 같이 낸다: 정식 주소 `unige.ai.kr` 과 1.0 이 쓰던 두 주소. 옛 주소에서 만든 초대 링크는 대표 주소 전환이
 * 켜져 있으면 정식 주소로 낸다(`domain-rollout.js` `canonicalInviteOrigin`).
 * 2026-10-18 — 옛 주소 → 정식 주소 계정 이전 화면(주소 안내 카드 · 계정 이전 창)은 걷어냈다(DESIGN 14.596). 옛 주소의 게스트는 그 주소에서 이어 한다.
 *
 * - 서버 쪽 같은 주소: `src/api/site-meta.ts` `PUBLIC_ORIGIN`(검색·공유 메타) · `public/index.html` canonical. 바꾸면 셋 다 고친다.
 */
export const CANONICAL_HOST = 'unige.ai.kr';
export const CANONICAL_ORIGIN = `https://${CANONICAL_HOST}`;
export const LEGACY_HOSTS = Object.freeze(['unige.flowlabs.ai.kr', 'game.flowlabs.ai.kr']);
